import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  getSalesPeopleDetails,
  getSalesPeopleResume,
} from '../../services/SalesPeople/getSalesPeople'

export const useSalesPeopleDetails = () => {
  const [SalesPeopleResume, setSalesPeopleResume] =
    useState<GetProductResumeType>()
  const [clientsDetails, setClientsDetails] = useState<GetDetailsType[]>([])
  const [clientsLow, setClientsLow] = useState<GetDetailsType[]>([])
  const [isLoading, setIsloading] = useState(true)

  const { id } = useParams()

  const handleSalesPeopleResume = async () => {
    setIsloading(true)
    const result = await getSalesPeopleResume(id!)
    setIsloading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setSalesPeopleResume(result)
    }
  }

  const handleClientsDetails = async (
    status: Classification,
    callback: (result: GetDetailsType[]) => void
  ) => {
    setIsloading(true)
    const result = await getSalesPeopleDetails(id!, status)
    setIsloading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      callback(result)
    }
  }

  const handleClientsInHigh = (result: GetDetailsType[]) => {
    const resultMapped = result.map(SalesPeople => ({
      ...SalesPeople,
      percentual: String(SalesPeople.percentual).replace('.', ','),
    }))
    setClientsDetails(resultMapped)
  }

  const handleClientsLow = (result: GetDetailsType[]) => {
    const resultMapped = result.map(SalesPeople => ({
      ...SalesPeople,
      percentual: String(SalesPeople.percentual).replace('.', ','),
    }))
    setClientsLow(resultMapped)
  }

  useEffect(() => {
    handleSalesPeopleResume()
  }, [])

  useEffect(() => {
    handleClientsDetails('EM_ALTA', handleClientsInHigh)
    handleClientsDetails('EM_BAIXA', handleClientsLow)
  }, [])

  return {
    SalesPeopleResume,
    clientsDetails,
    clientsLow,
    isLoading,
  }
}
